import { useState, useEffect } from "react";

import './Home.css';

import Select from 'react-select';

import JoditEditor from 'jodit-react';
import { config } from "fixedData";

import { GetListPag, RegisterListPag } from "interface/Page";
import { SetModalData, SetModalState } from "interface/PopUp";
import { GetDataPage, RegisterDataPage } from "interface/Data";

import { SvgVimeo, SvgYoutube } from "components/SvgFile";

export default function ModelPage_Home(props){

    const [ idioma, setIdioma ]     = useState(GetListPag('idioma'));
    const [ dataPage, setDataPage ] = useState(GetDataPage(props.origin));
    const [ idPage, setIdPage ]     = useState(GetListPag('currentPageId'));

    // pt_br
    const [ ptBrTitle, setPtBrTitle ]         = useState(InitialData('pt_br_title'));
    const [ ptBrTypeVideo, setPtBrTypeVideo ] = useState(InitialData('pt_br_type_video'));
    const [ ptBrFile, setPtBrFile ]           = useState(InitialData('pt_br_file'));
    const [ ptBrText, setPtBrText ]           = useState(InitialData('pt_br_text'));

    // en
    const [ enTitle, setEnTitle ]         = useState(InitialData('en_title'));
    const [ enTypeVideo, setEnTypeVideo ] = useState(InitialData('en_type_video'));
    const [ enFile, setEnFile ]           = useState(InitialData('en_file'));
    const [ enText, setEnText ]           = useState(InitialData('en_text'));

    // es
    const [ esTitle, setEsTitle ]         = useState(InitialData('es_title'));
    const [ esTypeVideo, setEsTypeVideo ] = useState(InitialData('es_type_video'));
    const [ esFile, setEsFile ]           = useState(InitialData('es_file'));
    const [ esText, setEsText ]           = useState(InitialData('es_text'));

    useEffect(()=>{
        RegisterListPag('idioma', setIdioma);
        RegisterDataPage(props.origin, setDataPage);
        RegisterListPag('currentPageId', setIdPage);

        LoadingData();
    }, []);

    useEffect(()=>{
        LoadingData();

        // pt_br
        setPtBrTitle(InitialData('pt_br_title'));
        setPtBrTypeVideo(InitialData('pt_br_type_video'));
        setPtBrFile(InitialData('pt_br_file'));
        setPtBrText(InitialData('pt_br_text'));

        // en
        setEnTitle(InitialData('en_title'));
        setEnTypeVideo(InitialData('en_type_video'));
        setEnFile(InitialData('en_file'));
        setEnText(InitialData('en_text'));

        // es
        setEsTitle(InitialData('es_title'));
        setEsTypeVideo(InitialData('es_type_video'));
        setEsFile(InitialData('es_file'));
        setEsText(InitialData('es_text'));        
    }, [dataPage, idPage]);


    function LoadingData(){
        props.RegisterData({ "pt_br_title": ptBrTitle, "pt_br_type_video": ptBrTypeVideo, "pt_br_file": ptBrFile, "pt_br_text": ptBrText, "en_title": enTitle, "en_type_video": enTypeVideo, "en_file": enFile, "en_text": enText, "es_title": esTitle, "es_type_video": esTypeVideo, "es_file": esFile, "es_text": esText });
    }

    function InitialData(type){
        if(idPage !=0){
            const newData = dataPage.find(item => item.id == idPage);
            if(type == 'pt_br_type_video' || type == 'en_type_video' || type == 'es_type_video'){
                return { "value": newData[type], "label": newData[type] }
            }
            return newData[type];
        }
        if(type == 'pt_br_type_video' || type == 'en_type_video' || type == 'es_type_video'){
            return { "value": "", "label": "#" }
        }
        return "";
    }

    function HandleData(type, value){
        switch (type) {
            case "ptBrTitle":
                    setPtBrTitle(value);
                    props.RegisterData({ "pt_br_title": value, "pt_br_type_video": ptBrTypeVideo.value, "pt_br_file": ptBrFile, "pt_br_text": ptBrText, "en_title": enTitle, "en_type_video": enTypeVideo.value, "en_file": enFile, "en_text": enText, "es_title": esTitle, "es_type_video.value": esTypeVideo.value, "es_file": esFile, "es_text": esText });
                break;

            case "ptBrTypeVideo":
                    setPtBrTypeVideo(value);
                    props.RegisterData({ "pt_br_title": ptBrTitle, "pt_br_type_video": value.value, "pt_br_file": ptBrFile, "pt_br_text": ptBrText, "en_title": enTitle, "en_type_video": enTypeVideo.value, "en_file": enFile, "en_text": enText, "es_title": esTitle, "es_type_video": esTypeVideo.value, "es_file": esFile, "es_text": esText });
                break;
                
            case "ptBrFile":
                    setPtBrFile(value);
                    props.RegisterData({ "pt_br_title": ptBrTitle, "pt_br_type_video": ptBrTypeVideo.value, "pt_br_file": value, "pt_br_text": ptBrText, "en_title": enTitle, "en_type_video": enTypeVideo.value, "en_file": enFile, "en_text": enText, "es_title": esTitle, "es_type_video": esTypeVideo.value, "es_file": esFile, "es_text": esText });
                break;
                
            case "ptBrText":
                    setPtBrText(value);
                    props.RegisterData({ "pt_br_title": ptBrTitle, "pt_br_type_video": ptBrTypeVideo.value, "pt_br_file": ptBrFile, "pt_br_text": value, "en_title": enTitle, "en_type_video": enTypeVideo.value, "en_file": enFile, "en_text": enText, "es_title": esTitle, "es_type_video": esTypeVideo.value, "es_file": esFile, "es_text": esText });
                break;

            case "enTitle":
                    setEnTitle(value);
                    props.RegisterData({ "pt_br_title": ptBrTitle, "pt_br_type_video": ptBrTypeVideo.value, "pt_br_file": ptBrFile, "pt_br_text": ptBrText, "en_title": value, "en_type_video": enTypeVideo.value, "en_file": enFile, "en_text": enText, "es_title": esTitle, "es_type_video": esTypeVideo.value, "es_file": esFile, "es_text": esText });
                break;

            case "enTypeVideo":
                    setEnTypeVideo(value);
                    props.RegisterData({ "pt_br_title": ptBrTitle, "pt_br_type_video": ptBrTypeVideo.value, "pt_br_file": ptBrFile, "pt_br_text": ptBrText, "en_title": enTitle, "en_type_video": value.value, "en_file": enFile, "en_text": enText, "es_title": esTitle, "es_type_video": value.value, "es_file": esFile, "es_text": esText });
                break;
                
            case "enFile":
                    setEnFile(value);
                    props.RegisterData({ "pt_br_title": ptBrTitle, "pt_br_type_video": ptBrTypeVideo.value, "pt_br_file": ptBrFile, "pt_br_text": ptBrText, "en_title": enTitle, "en_type_video": enTypeVideo.value, "en_file": value, "en_text": enText, "es_title": esTitle, "es_type_video": esTypeVideo.value, "es_file": esFile, "es_text": esText });
                break;
                
            case "enText":
                    setEnText(value);
                    props.RegisterData({ "pt_br_title": ptBrTitle, "pt_br_type_video": ptBrTypeVideo.value, "pt_br_file": ptBrFile, "pt_br_text": ptBrText, "en_title": enTitle, "en_type_video": enTypeVideo.value, "en_file": enFile, "en_text": value, "es_title": esTitle, "es_type_video": esTypeVideo.value, "es_file": esFile, "es_text": esText });
                break;
                
            case "esTitle":
                    setEsTitle(value);
                    props.RegisterData({ "pt_br_title": ptBrTitle, "pt_br_type_video": ptBrTypeVideo.value, "pt_br_file": ptBrFile, "pt_br_text": ptBrText, "en_title": enTitle, "en_type_video": enTypeVideo.value, "en_file": enFile, "en_text": enText, "es_title": value, "es_type_video": esTypeVideo.value, "es_file": esFile, "es_text": esText });
                break;

            case "esTypeVideo":
                    setEsTypeVideo(value);
                    props.RegisterData({ "pt_br_title": ptBrTitle, "pt_br_type_video": ptBrTypeVideo.value, "pt_br_file": ptBrFile, "pt_br_text": ptBrText, "en_title": enTitle, "en_type_video": enTypeVideo.value, "en_file": enFile, "en_text": enText, "es_title": esTitle, "es_type_video": value.value, "es_file": esFile, "es_text": esText });
                break;
                
            case "esFile":
                    setEsFile(value);
                    props.RegisterData({ "pt_br_title": ptBrTitle, "pt_br_type_video": ptBrTypeVideo.value, "pt_br_file": ptBrFile, "pt_br_text": ptBrText, "en_title": enTitle, "en_type_video": enTypeVideo.value, "en_file": enFile, "en_text": enText, "es_title": esTitle, "es_type_video": esTypeVideo.value, "es_file": value, "es_text": esText });
                break;
                
            case "esText":
                    setEsText(value);
                    props.RegisterData({ "pt_br_title": ptBrTitle, "pt_br_type_video": ptBrTypeVideo.value, "pt_br_file": ptBrFile, "pt_br_text": ptBrText, "en_title": enTitle, "en_type_video": enTypeVideo.value, "en_file": enFile, "en_text": enText, "es_title": esTitle, "es_type_video": esTypeVideo.value, "es_file": esFile, "es_text": value });
                break;
        }
    }

    function OpenFile(type, value){
        SetModalData("ShowFile", { "type": type, "file": value });
        SetModalState('ShowFile', true);
    }

    return(
        <div className="ModelPage_Home">
            {
                idioma == 'pt_br' ? 
                    <>
                        <div className="list_input_data">
                            <div className="div_input">
                                <Select className="select_type_video" defaultOptions options={[{ "value": "", "label": "#" }, { "value": "Vimeo", "label": "Vimeo" }, { "value": "Youtube", "label": "Youtube" }]} onChange={ (e)=> { HandleData('ptBrTypeVideo', e) } } value={ ptBrTypeVideo } placeholder="..." />
                                <span className="name_input">Origem do vídeo</span>
                            </div>
                            <div className="div_input">
                                <input type="text" onChange={ (e)=>{ HandleData('ptBrFile', e.target.value) } } value={ ptBrFile.replaceAll(' ', '') } required />
                                <span className="name_input">Código do vídeo</span>
                            </div>                            
                            {
                                ptBrFile == '' ? null :
                                <div className="div_input space_top" onClick={ ()=>{ OpenFile(ptBrTypeVideo.value, ptBrFile) } }>
                                    {
                                        ptBrTypeVideo.value == 'Vimeo' ? 
                                        <SvgVimeo color="#324d6b" className="show_icons_project"/> :
                                            ptBrTypeVideo.value == 'Youtube' ? <SvgYoutube color="#324d6b" className="show_icons_project"/> : null
                                    }
                                </div>
                            }
                        </div>

                        <div className="list_input_data">
                            <div className="div_input space_div show_data_text">
                                <div className="show_title">Título</div>
                                <JoditEditor className="height_textarea" config={ config } value={ ptBrTitle !='' ? ptBrTitle.replaceAll('&#34;', '"') : "" } onBlur={ newContent => HandleData('ptBrTitle', newContent) } />
                            </div>
                        </div>

                        <div className="list_input_data">
                            <div className="div_input space_div show_data_text">
                                <div className="show_title">Texto</div>
                                <JoditEditor className="height_textarea" config={ config } value={ ptBrText !='' ? ptBrText.replaceAll('&#34;', '"') : "" } onBlur={ newContent => HandleData('ptBrText', newContent) } />
                            </div>
                        </div>
                    </> :
                    idioma == 'en' ?
                        <>
                            <div className="list_input_data">
                                <div className="div_input">
                                    <Select className="select_type_video" defaultOptions options={[{ "value": "", "label": "#" }, { "value": "Vimeo", "label": "Vimeo" }, { "value": "Youtube", "label": "Youtube" }]} onChange={ (e)=> { HandleData('enTypeVideo', e) } } value={ enTypeVideo } placeholder="..." />
                                    <span className="name_input">Video source</span>
                                </div>
                                <div className="div_input">
                                    <input type="text" onChange={ (e)=>{ HandleData('enFile', e.target.value) } } value={ enFile.replaceAll(' ', '') } required />
                                    <span className="name_input">Video code</span>
                                </div>                         
                                {
                                    enFile == '' ? null :
                                    <div className="div_input space_top" onClick={ ()=>{ OpenFile(enTypeVideo.value, enFile) } }>
                                        {
                                            enTypeVideo.value == 'Vimeo' ? 
                                            <SvgVimeo color="#324d6b" className="show_icons_project"/> :
                                                enTypeVideo.value == 'Youtube' ? <SvgYoutube color="#324d6b" className="show_icons_project"/> : null
                                        }
                                    </div>
                                }
                            </div>

                            <div className="list_input_data">
                                <div className="div_input space_div show_data_text">
                                    <div className="show_title">Title</div>
                                    <JoditEditor className="height_textarea" config={ config } value={ enTitle !='' ? enTitle.replaceAll('&#34;', '"') : "" } onBlur={ newContent => HandleData('enTitle', newContent) } />
                                </div>
                            </div>

                            <div className="list_input_data">
                                <div className="div_input space_div show_data_text">
                                    <div className="show_title">Text</div>
                                    <JoditEditor className="height_textarea" config={ config } value={ enText !='' ? enText.replaceAll('&#34;', '"') : "" } onBlur={ newContent => HandleData('enText', newContent) } />
                                </div>
                            </div>
                        </>
                    :
                        <>
                            <div className="list_input_data">
                                <div className="div_input">
                                    <Select className="select_type_video" defaultOptions options={[{ "value": "", "label": "#" }, { "value": "Vimeo", "label": "Vimeo" }, { "value": "Youtube", "label": "Youtube" }]} onChange={ (e)=> { HandleData('esTypeVideo', e) } } value={ esTypeVideo } placeholder="..." />
                                    <span className="name_input">Fuente de vídeo</span>
                                </div>
                                <div className="div_input">
                                    <input type="text" onChange={ (e)=>{ HandleData('esFile', e.target.value) } } value={ esFile.replaceAll(' ', '') } required />
                                    <span className="name_input">Código do vídeo</span>
                                </div>                       
                                {
                                    esFile == '' ? null :
                                    <div className="div_input space_top" onClick={ ()=>{ OpenFile(esTypeVideo.value, esFile) } }>
                                        {
                                            esTypeVideo.value == 'Vimeo' ? 
                                            <SvgVimeo color="#324d6b" className="show_icons_project"/> :
                                                esTypeVideo.value == 'Youtube' ? <SvgYoutube color="#324d6b" className="show_icons_project"/> : null
                                        }
                                    </div>
                                }
                            </div>

                            <div className="list_input_data">
                                <div className="div_input space_div show_data_text">
                                    <div className="show_title">Título</div>
                                    <JoditEditor className="height_textarea" config={ config } value={ esTitle !='' ? esTitle.replaceAll('&#34;', '"') : "" } onBlur={ newContent => HandleData('esTitle', newContent) } />
                                </div>
                            </div>

                            <div className="list_input_data">
                                <div className="div_input space_div show_data_text">
                                    <div className="show_title">Texto</div>
                                    <JoditEditor className="height_textarea" config={ config } value={ esText !='' ? esText.replaceAll('&#34;', '"') : "" } onBlur={ newContent => HandleData('esText', newContent) } />
                                </div>
                            </div>
                        </>
            }
        </div>
    )
}